import {
  makeObservable, observable, action, runInAction,
} from 'mobx';
import orderBy from 'lodash/orderBy';
import to from 'await-to';
import client from 'utils/graphql';

import Royalties from 'graphql/queries/royalties.gql';
import { USER_ROLE } from '../components/shared/constants';
import formatVoizMonth from '../components/shared/utils/date-helpers/format-voiz-month';
import parseVoizMonthDate from '../components/shared/utils/date-helpers/parse-voiz-month-date';

import menuConfig from '../config/menu.js';

const { OWNER, INFLUENCER } = USER_ROLE;

export default class Config {
  static storeName = 'Config';

  client = null;

  token = null;

  menu = [];

  settings = [];

  loggedInUser = null;

  constructor(context = {}) {
    makeObservable(this, {
      menu: observable,
      loadMenu: action.bound,
    });

    Object.assign(this, context);

    this.client = client(this.token);

    runInAction(async () => {
      if (this.loggedInUser?.userRoles?.length) {
        await this.loadMenu();
      }
    });
  }

  async loadMenu() {
    const query = Royalties.loc.source.body;
    const [error, result] = await to(
      this.client.query(query, {
        orderBy: 'date_DESC',
        where: { owner: { id: this.loggedInUser.id } },
      }),
    );

    if (error) {
      throw new Error(error);
    }

    const monthItems = (slugBase) => orderBy(
      result.royaltiesConnection.edges.map(({ node }) => ({
        title: formatVoizMonth(node.date, 'YYYY - MMMM'),
        slug: `${slugBase}?id=${node.id}`,
        date: parseVoizMonthDate(node.date),
      })),
      ['date'],
      ['desc'],
    );

    const roles = (this.loggedInUser?.userRoles || []).map(({ role }) => role);
    const menu = [];

    if (roles.includes(OWNER)) {
      const [finance, books, ...staticSections] = menuConfig.owner;
      menu.push(
        { ...finance, items: monthItems('/owners/royaltyfinance') },
        { ...books, items: monthItems('/owners/royalty-books') },
        ...staticSections,
      );
    }

    if (roles.includes(INFLUENCER)) {
      const [commissions, ...staticSections] = menuConfig.influencer;
      menu.push(
        { ...commissions, items: monthItems('/affiliates/commissions') },
        ...staticSections,
      );
    }

    runInAction(() => {
      this.menu = menu;
    });
  }
}
